import React from 'react';
import {Card, CardBody, Col, Row} from 'reactstrap';
import ImportViewProcessedDataTable from "./ImportViewProcessedDataTable";
import { Link } from 'react-router-dom';
import axios from 'axios';
import { Button } from 'antd';

const ImportView = ({item, downloadImportCsv, onRunImport, isRunning, runMessage}) => {
  return (
    <>
      <Col md={12}>
        <Card>
          <CardBody>
            {onRunImport && (
              <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: 12, marginBottom: 12 }}>
                {runMessage && (
                  <span style={{ fontSize: 12, color: runMessage.type === 'success' ? '#28a745' : '#dc3545' }}>
                    {runMessage.text}
                  </span>
                )}
                <button
                  onClick={onRunImport}
                  disabled={isRunning}
                  style={{
                    backgroundColor: '#28a745',
                    color: '#fff',
                    border: 'none',
                    borderRadius: 4,
                    padding: '6px 14px',
                    fontSize: 13,
                    cursor: isRunning ? 'not-allowed' : 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    gap: 6,
                    opacity: isRunning ? 0.7 : 1,
                  }}
                >
                  {isRunning
                    ? <span style={{ display: 'inline-block', width: 12, height: 12, border: '2px solid #fff', borderTopColor: 'transparent', borderRadius: '50%', animation: 'spin 0.6s linear infinite' }} />
                    : <span>▶</span>
                  }
                  {isRunning ? 'Running...' : 'Run Import'}
                </button>
              </div>
            )}
            <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
            <div className="form__form-group-field">
              <div className="form__form-group" style={{maxWidth: 100}}>
                <h5>File Link</h5>
              </div>
              <div className="form__form-group">
                <Button onClick={() => downloadImportCsv(item)} color='link' variant='text' size='sm' >
                  Download
                </Button>
              </div>
            </div>

            <div className="form__form-group-field">
              <div className="form__form-group" style={{maxWidth: 100}}>
                <h5>File Name</h5>
              </div>
              <div className="form__form-group">
                {item.name}
              </div>
            </div>

            <div className="form__form-group-field">
              <div className="form__form-group" style={{maxWidth: 100}}>
                <h5>File Size</h5>
              </div>
              <div className="form__form-group">
                {item.size} Kb
              </div>
            </div>

            <div className="form__form-group-field">
              <div className="form__form-group" style={{maxWidth: 100}}>
                <h5>File Rows</h5>
              </div>
              <div className="form__form-group">
                {item.rowcount}
              </div>
            </div>

            <div className="form__form-group-field">
              <div className="form__form-group" style={{maxWidth: 100}}>
                <h5>Import Type</h5>
              </div>
              <div className="form__form-group">
                {item.csv_import_type.type}
              </div>
            </div>

            {item.csv_import_setting_id && (
              <div className="form__form-group-field">
                <div className="form__form-group" style={{maxWidth: 100}}>
                  <h5>Configuration</h5>
                </div>
                <div className="form__form-group">
                  <Link to={`/import/configurations/${item.csv_import_setting_id}`}>
                    #{item.csv_import_setting_id}
                  </Link>
                </div>
              </div>
            )}

            <div className="form__form-group-field">
              <div className="form__form-group" style={{maxWidth: 100}}>
                <h5>Imported</h5>
              </div>
              <div className="form__form-group">
                {/*{item.rows - item.errors.length}*/}
              </div>
            </div>

            <div className="form__form-group-field">
              <div className="form__form-group" style={{maxWidth: 100}}>
                <h5>Errors</h5>
              </div>
              <div className="form__form-group">
                {/*{item.errors.length && <ErrorsTable errors={item.errors} />}*/}
              </div>
            </div>

          </CardBody>
        </Card>
      </Col>
        <Col md={12}>
          <Card>
            <CardBody>
              <ImportViewProcessedDataTable/>
            </CardBody>
          </Card>
        </Col>
    </>
  )
}

export default ImportView;
